export const isRestorableLocationStateValid = restoreableLocationState => {
  if (!restoreableLocationState) {
    return false;
  }
  const hasValidState = typeof restoreableLocationState.state === 'string' && restoreableLocationState.state != null;
  if (hasValidState) {
    return true;
  }
  return false;
};